import React from 'react';
import { Query } from 'react-apollo';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAncillaryService } from '../../graphql/queries/ancillaryService';
import Header from '../common/Header';
import RenderImage from '../common/RenderImage';

const AncillaryService = () => {
  let { id } = useParams();
  const { t } = useTranslation();

  return (
    <div className="list">
      <Header
        title="ancillaryServices.show.title"
        linkTo={`/admin/ancillary_services/${id}/edit`}
        buttonLabel="shared.edit"
      />
      <Query {...getAncillaryService(id)}>
        {({ loading, data }) => {
          if (loading) return <div className="lds-dual-ring" />;
          if (data) {
            const { ancillaryService } = data;
            const ancillaryCategory = ancillaryService.ancillaryCategory

            return (
              <div className="common-show">
                <div className="grid">
                  <div className="col-12">
                    <div className="common-show__infos">
                      <div className="col-12">
                        <div className="common-show__infos--field">
                          {t('ancillaryServices.attributes.ssrCode')}
                        </div>
                        <div className="common-show__infos--value">{ancillaryService.ssrCode}</div>
                        <div className="common-show__infos--field">
                          {t('ancillaryServices.attributes.description')}
                        </div>
                        <div className="common-show__infos--value">
                          {ancillaryService.description || t('shared.notAvailable')}
                        </div>
                        <div className="common-show__infos--field">
                          {t('ancillaryServices.attributes.serviceType')}
                        </div>
                        <div className="common-show__infos--value">
                          {ancillaryService.serviceType}
                        </div>
                        <div className="common-show__infos--field">
                          {t('ancillaryServices.attributes.fullDescription')}
                        </div>
                        <div className="common-show__infos--value">
                          {ancillaryService.fullDescription || t('shared.notAvailable')}
                        </div>
                        <div className="common-show__infos--field">
                          {t('ancillaryServices.attributes.ancillaryCategory')}
                        </div>
                        <div className="common-show__infos--value">
                          {ancillaryCategory ? ancillaryCategory.identifier : t('shared.notAvailable')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="common-show__images">
                  <div className="common-show__infos--field">
                    {t('ancillaryServices.attributes.image')}
                  </div>
                  <RenderImage url={ancillaryService.imageUrls.large} />
                </div>
              </div>
            );
          }
          return null;
        }}
      </Query>
    </div>
  );
};

export default AncillaryService;
